<template>
    <div class="card card-height">
        <div class="table-container">
            <table class="table create-billing table-width">
                												
                <thead>
                    <tr>
                        <th>SL</th>
                        <th class=" pl-10 particular">Item Details</th>
                        <th class="text-right mx-w-50">Qty</th>
                        <th class="text-right mx-w-50">Rate</th>
                        <th class="text-right mx-w-50">Amount</th>
                        <th class="th-action"></th>
                    </tr>
                </thead>

                <tbody class="border-bottom" ref="tableRef">
                    <RowInline
                        v-for="(item, i) in tableItems" :key="item.id"
                        :item="item" :index="i"
                        @onDeleteItem="onDeleteItem"
                    />
                </tbody>
            </table>
        <p v-if="!tableItems.length" class="text-center mt-5">No data</p>
    </div>

    <div class="row mt-4">
        <div class="col-md-5">
            <div class="mb-1">
                <label class="form-label" for="description">Note</label>
                <vField
                    as="textarea"
                    name="description"
                    type="number"
                    class="form-control"
                    v-model="formData.description"
                    :disabled="route.params.invoiceId"
                />
            </div>

            <MoneyReceiptForm :grand-total="grandTotal" :cashAndBank="cashAndBank"/>
        </div>
        <div class="col-md-6 ml-auto">
            <div>	
                <table class="table create-billing border table-totals">
                    <tbody>
                        <tr>
                            <td class="product px-2">Sub-Total Amount</td>
                            <td class="comma-sep">:</td>
                            <td class="price text-right px-2"> {{ subTotal }}</td>
                        </tr>
                        <tr>
                            <td class="product px-2 d-flex w-100">Total Discount / Round up Adj
                                <div class="price-adj">
                                    <span class="mr-5"></span>
                                    <input
                                        v-model.trim="discountPercent"
                                        type="number" class="form-control form-control-sm discount-adj ml-auto text-right font-20"
                                        placeholder="%" :min="0"
                                        :disabled="invoiceId"
                                    >
                                </div>
                            </td>
                            <td class="comma-sep">:</td>
                            <td class="price">
                                <div class="price-adj px-2">
                                    <span class="mr-5"></span>
                                    <input
                                        v-model.trim="discountAmount"
                                        type="number" class="form-control form-control-sm discount-adj ml-auto text-right font-20"
                                        placeholder="amount" :min="0"
                                        :disabled="invoiceId"
                                    >
                                </div>
                            </td>
                        </tr>
                        <tr v-if="discountAmount > 0">
                            <td class="product px-2">Select discount head</td>
                            <td class="comma-sep">:</td>
                            <td style="font-weight: normal">
                                <v-select
                                    placeholder="Select Discount Head"
                                    v-model="formData.discount_head_id"
                                    :options="salesAccountHeads"
                                    label="name"
                                    :reduce="name => name.id"
                                    :disabled="invoiceId"
                                />
                            </td>
                        </tr>

                        <tr v-if="formData && formData.referrer_id">
                          <td class="product px-2 d-flex w-100">Hospital Discount</td>
                          <td class="comma-sep">:</td>
                          <td class="price">
                            <div class="price-adj px-2">
                              <span class="mr-5"></span>
                              <input
                                  disabled
                                  v-model.trim="hospitalDiscount"
                                  type="text" class="form-control form-control-sm discount-adj ml-auto text-right"
                                  placeholder="amount"
                              >
                            </div>
                          </td>
                        </tr>

                        <tr v-if="formData && formData.referrer_id">
                          <td class="product px-2 d-flex w-100">Referrer Discount
                            <div class="price-adj">
                              <span class="mr-5"></span>
                               <button @click="referrerDiscountFiftyPercent" class="btn btn-outline-primary btn-sm ml-auto text-right">50%?</button>
                            </div>
                          </td>
                          <td class="comma-sep">:</td>
                          <td class="price">
                            <div class="price-adj px-2">
                              <span class="mr-5"></span>
                              <input
                                  v-model.trim="referrerDiscount"
                                  type="text" class="form-control form-control-sm discount-adj ml-auto text-right"
                                  placeholder="amount"
                                  @blur="updateReferrerDiscount"
                                  :disabled="invoiceId"
                              >
                            </div>
                          </td>
                        </tr>

                        <tr>
                            <td>
                              <h1 class="text-right">Net Bill</h1>
                            </td>
                            <td class="comma-sep">:</td>
                          <div class="py-2 px-1">
                                <input
                                  v-model.trim="grandTotal"
                                  type="number" class="form-control form-control-sm text-right font-20"
                                  placeholder="amount" :min="0"
                                  :disabled="invoiceId"
                                >
                            </div>
                        </tr>

                        <tr>
                            <td>
                              <h1 class="text-right">Paid Amount</h1>
                            </td>
                            <td class="comma-sep">:</td>
                            <div class="py-2 px-1">
                                <input
                                    v-model="formData.payment"
                                    name="amount"
                                    type="number"
                                    class="form-control form-control-sm text-right font-20"
                                    @keyup="validatePaymentAmount"
                                    :disabled="invoiceId"
                                >
                            </div>
                        </tr>

                        <tr>
                            <td>
                              <h1 class="text-right">Due Amount</h1>
                            </td>
                            <td class="comma-sep">:</td>
                            <div class="py-2 px-1">

                                <input
                                    :value="dueAmount"
                                    name="amount"
                                    type="number"
                                    class="form-control form-control-sm text-right font-20"
                                    disabled
                                >
                            </div>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
</div>
</template>

<script setup>    
    import RowInline from '@/components/molecule/company/hospital/billing/investigation/dc/InvoiceTableRow.vue';
    import useDetectOutsideClick from '@/services/useDetectOutsideClick';
    import { computed, ref, watch, inject } from 'vue';
    import MoneyReceiptForm from "@/components/molecule/company/hospital/billing/investigation/dc/MoneyReceiptForm.vue";
    import { useRoute } from "vue-router";

    const route = useRoute();
    const tableRef = ref(null)
    const discountAmount = ref(null);
    const referrerDiscount = ref(0);
    const hospitalDiscount = ref(0);
    const discountPercent = ref(null);
    const grandTotal = ref(0);
    const totals = inject('totals');
    const formData = inject("formData");

    const invoiceId = computed(() => route.params.invoiceId);

    const props = defineProps({
        tableItems: {
            type: Array
        },
        salesAccountHeads: {
            type: Array
        },
        subTotalVal: {
            type: Number
        },
        totalVatVal: {
            type: Number
        },
        totalVal: {
            type: Number
        },
        isHideAddBtn: {
            type: Boolean,
            default: false
        },
        maxHospitalDiscountPercentage : {
            type: Number,
            default: 0
        },
        cashAndBank: {
            type: Array,
        }
    })

    const subTotal = computed(() => {
        let subTotal=0
        props.tableItems.map(item => { subTotal += parseInt((item.quantity * item.rate) - item.discount_amount) })
        totals.value.subTotalVal = subTotal;
        return subTotal
    })

    const totalVAT = computed(() => {
        let vat=0
        props.tableItems.map(item => {
            if(item.vat_amount) {
              vat += parseFloat(item.vat_amount)
            }
        })
        totals.value.totalVatVal = vat;
        return vat.toFixed(2)
    })

    const total = computed(() => {
        var totalValue = parseInt(subTotal.value) + parseInt(totalVAT.value);
        totals.value.totalVal = totalValue
        return totalValue
    })

    const dueAmount = computed(() => {
        let due = grandTotal.value - (formData.value.payment ? formData.value.payment : 0);
        return due < 0 ? 0 : due;
    })

    watch(
        () => formData.value.total_discount,
        (newValue, oldValue) => {
            if (newValue !== oldValue) {
                discountAmount.value = formData.value.total_discount;
            }
        }
    )

    watch(discountAmount, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        grandTotal.value = total.value - discountAmount.value
        formData.value.adjustment_amount = discountAmount.value
        hospitalDiscount.value = 0;
        referrerDiscount.value = 0;
      }
    })

    watch(referrerDiscount, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        formData.value.referrer_discount_amount = referrerDiscount.value
      }
    })

    watch(discountPercent, () => {
      if(discountPercent.value == 0){
        return discountAmount.value = 0;
      }

      if (!discountPercent.value){
        return discountAmount.value = null;
      }

      return discountAmount.value = (total.value * discountPercent.value) / 100;
    })

    const referrerDiscountFiftyPercent = () => {
        let maxHospitalDiscount = (total.value * props.maxHospitalDiscountPercentage) / 100;
        let splitDiscountAmount = discountAmount.value / 2;
        hospitalDiscount.value = splitDiscountAmount

        if (splitDiscountAmount > maxHospitalDiscount){
          hospitalDiscount.value = maxHospitalDiscount
        }

        referrerDiscount.value = discountAmount.value - hospitalDiscount.value
    }

    const updateReferrerDiscount = () => {
      let maxHospitalDiscount = (total.value * props.maxHospitalDiscountPercentage) / 100;
      if (referrerDiscount.value > discountAmount.value){
        referrerDiscount.value = discountAmount.value
      }

      let minReferrerDiscount = discountAmount.value - maxHospitalDiscount;

      if (referrerDiscount.value < minReferrerDiscount) {
        referrerDiscount.value = minReferrerDiscount;
      }

      let hospitalDiscountAmount = discountAmount.value - referrerDiscount.value;

      if (hospitalDiscountAmount > maxHospitalDiscount) {
        hospitalDiscountAmount = maxHospitalDiscount;
        referrerDiscount.value = discountAmount.value - hospitalDiscountAmount;
      }

      hospitalDiscount.value = hospitalDiscountAmount;
    };

    watch(total, (value) => {
      grandTotal.value = total.value - discountAmount.value;
    })

    watch(grandTotal, (newValue, oldValue) => {
      if (newValue !== oldValue && newValue != 0) {
        discountAmount.value = total.value - newValue;
      }
    })

    useDetectOutsideClick(tableRef, () => {
        resetItemList();
    })

    const onDeleteItem = (index) => {
        props.tableItems.splice(index, 1);
    }

    const resetItemList = (selectedIndex = -1) => {
        for(let i = 0; i < props.tableItems.length; i++){
            
            if(selectedIndex === i){
                props.tableItems[i].isEdit = true;
                continue;
            }
            props.tableItems[i].isEdit = false;
        }
    }

    const validatePaymentAmount = (event) => {
        const amount = event.target.value
        if (amount < 0) {
            showError("Payment Amount cannot be less than 0")
        }
    }

    const resetData = () => {
      discountPercent.value = null;
      discountAmount.value = null;
      referrerDiscount.value = 0;
    }

    defineExpose({
      resetData
    })
</script>

<style>
.price-adj{
    display: flex;
    align-items: center;
}

.discount-adj{
    width: 60%;
}

.create-billing > :not(first-child) > * {
    padding-left: 10px !important;
}

.table-totals{
    font-weight: bold;
}
.product{
    width: 60%;
}
.comma-sep{
    text-align: right;
}

.create-billing > :not(caption) > * > * {
    padding: 0.72rem 0.2rem;
}
.particular{
    width: 25%;
}
.qty{
    width: 6%;
}
.discount{
    width: 5%;
}
.card-height{
    min-height: 200px
}
.add-new-line {
    margin-top: 4%;
}
.font-20 {
    font-size: 20px;
}
.th-action {
    max-width: 20px;
}
.mx-w-50 {
    max-width: 50px;
}
</style>